import store from '@/state/store';

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // if (process.env.VUE_APP_DEFAULT_AUTH === 'firebase') {
        //   store.dispatch('auth/logOut');
        // } else {
        //   store.dispatch('authentication/logout');
        // }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push('/login')
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom }
        );
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/lista/tiendas',
    name: 'list-store',
    meta: { 
      authRequired: true,
      permissions: ['view_store']
    },
    component: () => import('./views/store/storeList'),
  },
  {
    path: '/lista/productos',
    name: 'list-products',
    meta:{ 
      authRequired: true,
      permissions: ['view_product']
    },
    component: () => import('./views/products/productList')
  },
  {
    path: '/agregar/producto',
    name: 'add-product',
    meta: { 
      authRequired: true,
      permissions: ['add_product']
    },
    component: () => import('./views/products/productCreate')
  },
  {
    path: '/editar/producto/:sku',
    name: 'update-product',
    meta: { 
      authRequired: true,
      permissions: ['change_product']
    },
    component: () => import('./views/products/productEdit')
  },
  {
    path: '/producto/:sku/logs',
    name: 'product_log',
    meta: {
      authRequired: true,
      permissions: ['view_productlog']
    },
    component: () => import('./views/products/ProductLog')
  },
  {
    path: '/ingreso/inventario',
    name: 'income-inventory',
    meta: { 
      authRequired: true,
      permissions: ['add_income']
    },
    component: () => import('./views/inventory/incomeInventory')
  },
  {
    path: '/egreso/inventario',
    name: 'expense-inventory',
    meta: { 
      authRequired: true,
      permissions: ['add_expense']
    },
    component: () => import('./views/inventory/expenseInventory')
  },
  {
    path: '/lista/despachos',
    name: 'list-dispatchs',
    meta: { 
      authRequired: true,
      permissions: ['view_package']
    },
    component: () => import('./views/dispatchs/listDispatch')
  },
  {
    path: '/lista/devoluciones',
    name: 'list-returns',
    meta: {
      authRequired: true,
      permissions: ['view_package']
    },
    component: () => import('./views/returns/ListReturn')
  },
  {
    path: '/lista/despachos-anulados',
    name: 'cancel_dispatchs',
    meta: {
      authRequired: true,
      permissions: ['view_package']
    },
    component: () => import('./views/dispatchs/ListCancelDispatch')
  },
  {
    path: '/guia/crear',
    name: 'guide-local-create',
    meta: {
      authRequired: true,
      permissions: ['add_guidelocal']
    },
    component: () => import('./views/guideLocal/create')
  },
  {
    path: '/guia/lista',
    name: 'guide-local-list',
    meta: {
      authRequired: true,
      permissions: ['view_guidelocal']
    },
    component: () => import('./views/guideLocal/list')
  },
  {
    path: '/guia/impresion-masiva',
    name: 'guide-masive-print',
    meta: {
      authRequired: true,
      permissions: ['view_guidelocal']
    },
    component: () => import('./views/guideLocal/MasivePrint')
  },
  {
    path: '/domicilio/lista',
    name: 'lista-domicilio',
    meta: {
      authRequired: true,
      permissions: ['view_delivery']
    },
    component: () => import('./views/domicilio/Domicilio')
  },
  {
    path: '/guia-pendiente/lista',
    name: 'pending_guide_list',
    meta: {
      authRequired: true,
      permissions: ['view_pendingguides']
    },
    component: () => import('./views/pendingGuide/PendingGuide')
  },

  // Rutas de novedades
  {
    path: '/novedades/lista',
    name: 'novelty_list',
    meta: {
      authRequired: true,
      permissions: ['view_novelty']
    },
    component: () => import('./views/novelty/List')
  },

  // Rutas de autorizaciones
  {
    path: '/autorizacion/lista',
    name: 'authorization_list',
    meta: {
      authRequired: true,
      permissions: ['view_authorizationguidelocal']
    },
    component: () => import('./views/authorizations/List')
  },
  // Rutas de wallet
  {
    path: '/wallet/tiendas',
    name: 'wallet_list',
    meta: {
      authRequired: true,
      permissions: ['view_wallet']
    },
    component: () => import('./views/wallet/WalletStoreList')
  },
  {
    path: '/wallet/detail/:id',
    name: 'wallet_detail',
    meta: {
      authRequired: true,
      permissions: ['view_wallet']
    },
    component: () => import('./views/wallet/WalletDetail')
  },

  // Rutas de solicitud de retiro
  {
    path: '/solicitud-retiro/lista',
    name: 'retreat_list',
    meta: {
      authRequired: true,
      permissions: ['view_retreat']
    },
    component: () => import('./views/retreat/List')
  },

  {
    path: '/lista/mercancia/seguimiento',
    name: 'commodity_tracking',
    meta: {
      authRequired: true,
      permissions: ['view_commodity']
    },
    component: () => import('./views/commodity/listCommodity')
  },
  {
    path: '/crear/mercancia/seguimiento',
    name: 'create_commodity_tracking',
    meta: {
      authRequired: true,
      permissions: ['view_commodity']
    },
    component: () => import('./views/commodity/create')
  },

  {
    path: '/lista/ordenes-shopify',
    name: 'list_shopify_orders',
    meta: {
      authRequired: true,
      permissions: ['view_shopifyorder']
    },
    component: () => import('./views/shopify/list')
  },

  {
    path: '/crear/tienda',
    name: 'create_store',
    meta: {
      authRequired: true,
      permissions: ['admin_permission']
    },
    component: () => import('./views/store/StoreCreate')
  },

  {
    path: '/lista/tienda',
    name: 'all_store',
    meta: {
      authRequired: true,
      permissions: ['admin_permission']
    },
    component: () => import('./views/store/ListStore')
  },
  {
    path: '/actualizar/tienda/:id',
    name: 'change_store',
    meta: {
      authRequired: true,
      permissions: ['admin_permission']
    },
    component: () => import('./views/store/StoreUpdate')
  },
  {
    path: '/crear/usuario',
    name: 'create_user',
    meta: {
      authRequired: true,
      permissions: ['admin_permission']
    },
    component: () => import('./views/users/UserCreate')
  },
  {
    path: '/lista/usuarios',
    name: 'list_user',
    meta: {
      authRequired: true,
      permissions: ['admin_permission']
    },
    component: () => import('./views/users/UserList')
  },
  {
    path: '/actualizar/usuario/:id',
    name: 'update_user',
    meta: {
      authRequired: true,
      permissions: ['admin_permission']
    },
    component: () => import('./views/users/UserUpdate')
  },
  {
    path: '/pedido/liquidar',
    name: 'liquidate_delivery',
    meta: {
      authRequired: true,
      permissions: ['liquidate_delivery']
    },
    component: () => import('./views/guideLocal/Liquidate')
  },
  {
    path: '/movimientos/traslados',
    name: 'trasnfer_list',
    meta: {
      authRequired: true,
      permissions: ['view_transfer']
    },
    component: () => import('./views/inventory/transferList.vue')
  }

]